import ErrorBoundryWrapper from "./ErrorBoundry";
export const ErrorBoundry = ErrorBoundryWrapper;
